import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackButtonClick } from '../lib/analytics';

const EcosystemSection = () => {
  const navigate = useNavigate();

  const systems = [
    {
      title: '財富流 (Wealth Flow)',
      description: '練習在受限的資源與時間內，如何透過精力配置與合作打破困局、顯化財富。',
      gradient: 'from-orange-400 to-red-400',
      path: '/wealth-flow',
      testid: 'ecosystem-card-wealth-flow'
    },
    {
      title: '明日之星 (Rising Stars)',
      description: '激發勇於跨出舒適圈的探索欲，找回學童時期的純粹，大膽定義自己的未來。',
      gradient: 'from-yellow-400 to-orange-400',
      path: '/rising-stars',
      testid: 'ecosystem-card-rising-stars'
    },
    {
      title: '時空流 (Space-Time Flow)',
      description: '站在生命長河的高度，進行高階決策模擬，重塑對時間與生命掌控的自覺。',
      gradient: 'from-red-400 to-pink-400',
      path: '/spacetime-flow',
      testid: 'ecosystem-card-spacetime-flow'
    }
  ];

  const handleClick = (path, title) => {
    if (path) {
      trackButtonClick(title, 'ecosystem_section');
      navigate(path);
    }
  };

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Game-based Learning Ecosystem</h2>
            <h3 className="text-3xl font-bold text-orange-500">三大生命模擬系統</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {systems.map((system, index) => (
              <div
                key={index}
                data-testid={system.testid}
                onClick={() => handleClick(system.path, system.title)}
                className={`relative group ${system.path ? 'cursor-pointer' : ''}`}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${system.gradient} rounded-2xl opacity-10 group-hover:opacity-20 transition-opacity duration-300`}></div>
                <div className="relative bg-white border-2 border-orange-200 rounded-2xl p-8 hover:border-orange-400 transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                  <h4 className="text-2xl font-bold text-gray-800 mb-4">{system.title}</h4>
                  <p className="text-gray-700 leading-relaxed">{system.description}</p>
                  {system.path && (
                    <p className="mt-4 text-orange-500 font-semibold text-sm group-hover:underline">
                      了解更多 →
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
